module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_750_Inactive@1x-4604a11d04436903f9784eabee80ee27.png";